/* THIS FILE IS GENERATED. DO NOT EDIT */

import theme from 'base/components/standalone/SubscriptionDetails/Digital/History/Item/theme';

export const SubscriptionDetailsDigitalHistoryItemTheme = theme;
